import React from 'react';
import classnames from 'classnames';
import ListCard from './list-card';

const IndentedListCard = (props) => {
  const { className, ...cardProps } = props;
  return (
    <ListCard
      className={classnames('indented-list-card', className)}
      {...cardProps}
    />
  );
};

IndentedListCard.propTypes = {
  ...ListCard.propTypes,
};

export default IndentedListCard;
